import { render } from "./StorePage.vue?vue&type=template&id=0fabc8cf&scoped=true"
import script from "./StorePage.vue?vue&type=script&lang=js"
export * from "./StorePage.vue?vue&type=script&lang=js"

import "./StorePage.vue?vue&type=style&index=0&id=0fabc8cf&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0fabc8cf"]])

export default __exports__